import React from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
    CalendarIcon,
    RupeeIcon,
    FieldWrapper
} from "../../Styles/InputStyle2";
import { Select, MenuItem, Menu } from "@mui/material";
// import DropzoneImageUpload from "../Properties/DropzoneImageUpload";
import { FaUserPlus } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";

const EditMaintenanceWarranty = ({ onClose, stepOneData, setSelectedForm,setEditMaintenanceDetails }) => {
    const initialValues = {
        expiryDate: "",
        maintenanceDate: "",
        scheduleMaintenanceDate: "",
        notes: "Required for renewal of warranty and maintenance",
        assignVendor: "3",

    };
    const vendorList = [
        { id: "1", name: "Vendor 1" },
        { id: "2", name: "Vendor 2" },
        { id: "3", name: "Vendor 3" },
        { id: "4", name: "Vendor 4" },
        { id: "5", name: "Vendor 5" },
    ];


    const handleSubmit = (values) => {
        const payload = {
            maintenanceDate: values.maintenanceDate,
            expiryDate: values.expiryDate,
            scheduleMaintenanceDate: values.scheduleMaintenanceDate,
            notes: values.notes,
            assignVendor: values.assignVendor,
        }
        // setSelectedForm("5");
        console.log("payload data from maintenance", payload);
        setEditMaintenanceDetails(false);
    };
    const handleBack = () => {
        // console.log("back button clicked");
        setEditMaintenanceDetails(false);
        // setSelectedForm("3");
    }

    return (

        <Container>
            <Header>
                <Title>{"Edit Maintenance Details"}</Title>
                <CloseButton onClick={() => setEditMaintenanceDetails(false)}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            <Content>
                <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue }) => (
                        <Form className="px-2">
                            {/* <ModalSubHeading>Step 4</ModalSubHeading> */}
                            {/* <ModalHeading>Expiry/Warranty Details</ModalHeading> */}
                            <ScrollableContent>
                                <Wrapper>

                                    <InputGroup>
                                        <Label htmlFor="expiryDate">Expiry Date *</Label>
                                        <FieldWrappers className="bg-gray-100">
                                            <CalendarIcon />
                                            <input
                                                type="date"
                                                id="expiryDate"
                                                // onChange={(e) => {
                                                //     setFieldValue("expiryDate", e.target.value);
                                                // }}
                                                value={values.expiryDate}
                                                className="pl-6 text-gray-500"
                                                disabled

                                            />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <CombineInputGroup>
                                        <InputGroup>
                                            <Label htmlFor="maintenanceDate">Last Maintenance Date </Label>
                                            <FieldWrappers>
                                                <CalendarIcon />
                                                <input
                                                    type="date"
                                                    id="maintenanceDate"
                                                    // {...formik.getFieldProps("dueDate")}
                                                    onChange={(e) => {
                                                        setFieldValue("maintenanceDate", e.target.value);
                                                    }}
                                                    value={values.maintenanceDate}
                                                    className="pl-6"
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="scheduleMaintenanceDate">Next Maintenance Date </Label>
                                            <FieldWrappers>
                                                <CalendarIcon />
                                                <input
                                                    type="date"
                                                    id="scheduleMaintenanceDate"
                                                    // {...formik.getFieldProps("dueDate")}
                                                    onChange={(e) => {
                                                        setFieldValue("scheduleMaintenanceDate", e.target.value);
                                                    }}
                                                    value={values.scheduleMaintenanceDate}
                                                    className="pl-6"
                                                />
                                            </FieldWrappers>
                                        </InputGroup>

                                    </CombineInputGroup>
                                    <InputGroup>
                                        <Label htmlFor="notes">Maintenance Notes </Label>

                                        <Field
                                            as={Textarea}
                                            id="notes"
                                            name="notes"
                                            rows={4}
                                            placeholder="Enter Maintenance Notes"
                                        />

                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="assignVendor">Assign Vendor For Maintenance </Label>
                                        <Select
                                            id="assignVendor"
                                            name="assignVendor"
                                            className="w-full px-2"
                                            onChange={(e) => {
                                                setFieldValue("assignVendor", e.target.value);
                                            }}
                                            value={values.assignVendor}

                                        >
                                            <MenuItem value="" disabled>Select Vendor</MenuItem>
                                            {vendorList.map((vendor) => (
                                                <MenuItem key={vendor.id} value={vendor.id}
                                                >
                                                    {vendor.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </InputGroup>
                                    <div className="flex items-end justify-end -mt-2">
                                        <Vendor type="button" onClick={() => {
                                            // setIsShowAddExpenses(false);
                                            // setIsAddVendor(true);

                                        }}><FaUserPlus className="mr-1 mt-0.5"
                                            />Add Vendor</Vendor>
                                    </div>


                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleBack}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit">
                                    Submit
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </Content>
        </Container>
    );
};
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const CombineInputGroup = tw.div`w-full flex md:flex-row flex-col space-x-4 items-end`;
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;


export default EditMaintenanceWarranty;